export default {
      id: "login-vk-usage",
      viewBox: "0 0 20 12",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-vk-usage",
      toString: function () {
        return this.url;
      }
    }